import React from "react";
import arrowRight from "../../../assets/images/arrow-right-big.svg";

interface Props {
  title: string | null | undefined;
}

export const GoToMainContentBtn = ({ title }: Props) => (
  <a
    className="absolute flex gap-4 items-center left-3 top-3 leading-none rounded-lg p-3 normal-case text-brand-primary-20 no-underline font-bold tracking-normal border bg-white z-[100] pointer-events-none focus:pointer-events-auto focus:ring-4 focus:border-input-border-focused focus:shadow-outline focus:outline-none transition opacity-0 focus:opacity-100 md:text-xl md:left-4 md:py-3.5 md:px-4"
    href="#main-content"
  >
    {title}
    <svg className="size-4 md:size-5" width={20} height={20}>
      <use xlinkHref={arrowRight.url} />
    </svg>
  </a>
);

